import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';
import { NotFoundPageContainer } from './components/app/NotFound';

const router = createRouter({
  routeTree,
  defaultNotFoundComponent: NotFoundPageContainer,
  notFoundMode: 'root',
  defaultPendingMinMs: 0,
  defaultStructuralSharing: true,
  trailingSlash: 'always',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }

  interface StaticDataRouteOption {
    secure: boolean;
  }
}

const rootElement = document.getElementById('platform_root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<RouterProvider router={router} />);
}
